// extracted by mini-css-extract-plugin
export var cardHeader = "_ho-1";
export var contentCard = "_ho-0";
export var headerActions = "_ho-3";
export var reorderHandle = "_ho-5";
export var titleArea = "_ho-2";
export var titleAreaWithHandle = "_ho-4";